import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  AdminContractService,
  AggregateUnit,
  FilterValues,

} from '@shared/services/admin-contract.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Contract } from '@shared/models/contract';
import { ToastrService } from '@shared/services/toastr.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, distinctUntilChanged, Subscription } from 'rxjs';
import { GoBackButtonComponent } from '@shared/components/go-back-button/go-back-button.component';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';
import { FormsModule } from '@angular/forms';
import { ContractFiltersActionbar } from '@shared/components/contract-filters-actionbar/contract-filters-actionbar';
import { ContractGraphsComponent } from '@shared/components/contract-graphs/contract-graphs.component';
import { InvoicingFilters, InvoicingReport } from '@shared/services/abstract-contract.service';

@Component({
  selector: 'app-contract-invoicing-report',
  templateUrl: './contract-invoicing-report.component.html',
  styleUrls: ['./contract-invoicing-report.component.scss'],
  imports: [
    GoBackButtonComponent,
    BadgeOrganizationComponent,
    FormsModule,
    RouterLink,
    ContractFiltersActionbar,
    ContractGraphsComponent,
    TranslatePipe,
  ],
})
export class ContractInvoicingReportComponent implements OnInit, OnDestroy {
  contract: Contract;
  invoicingReport: InvoicingReport;
  public filterValues: FilterValues = {
    tags: [],
    organizations: [],
    clusters: [],
  };

  private readonly contractId = this.route.snapshot.paramMap.get('contractRef');
  private filters$: BehaviorSubject<InvoicingFilters> = new BehaviorSubject<InvoicingFilters>(undefined);
  private subscriptions$: Subscription = new Subscription();

  nbMonth = 12;
  aggregateUnit: AggregateUnit = 'MONTH';

  constructor(
    private route: ActivatedRoute,
    private contractService: AdminContractService,
    public translate: TranslateService,
    private toastrService: ToastrService,
  ) {
    this.subscriptions$.add(
      this.route.data.subscribe(({ contract }: { contract: Contract }) => {
        this.contract = contract;
      }),
    );
  }

  public ngOnInit(): void {
    this.subscriptions$.add(
      this.contractService.getFilterValues(this.contractId, { nbPeriods: this.nbMonth, aggregateUnit: this.aggregateUnit }).subscribe({
        next: (list: FilterValues) => (this.filterValues = list),
        error: (err: HttpErrorResponse) => this.toastrService.error(err?.message),
      }),
    );

    this.subscriptions$.add(
      this.filters$.pipe(distinctUntilChanged()).subscribe({
        next: () => this.refreshData(),
        error: (err) => this.toastrService.error(err?.message),
      }),
    );
  }

  public ngOnDestroy() {
    this.subscriptions$.unsubscribe();
  }

  public onChangeFilter(value: InvoicingFilters) {
    this.filters$.next(value);
  }

  refreshData() {
    this.subscriptions$.add(
      this.contractService
        .getInvoicingReport(this.contractId, {
          aggregateUnit: this.aggregateUnit,
          ...this.filters$.getValue(),
          nbPeriods: this.nbMonth,
        })
        .subscribe((invoicingReport) => {
          this.invoicingReport = invoicingReport;
        }),
    );
  }
}

